import axios from "axios";

export const fetchGallery = () => {
    return async dispatch => {
        try {
            dispatch({type: 'FETCH_GALLERY'});
            const response = await axios.get(`https://holz-city.ru:444/gallery`);
            dispatch({type: 'FETCH_GALLERY_SUCCESS', payload: response.data});
        } catch (e) {
            dispatch({
                type: 'FETCH_GALLERY_ERROR',
                payload: 'Произошла ошибка при загрузки'
            });
        }
    }
}